import { datadogRum } from "@datadog/browser-rum";
import { getFeatureFlag, isBoolean } from "@sinch/feature-flags";
import type { OnesaasConsent } from "../components/CookieBanner/onesaas-consent-cookie";
import { createClientEvent } from "./createClientEvent";
import { createGA4Event } from "./ga4/createGA4Event";
import { hasUserConsentedToEvent } from "./hasUserConsentedToEvent";
import { trackRudderStackEvent } from "./rudderstack";
import { createRudderStackClientEvent } from "./rudderstack/createRudderstackEvent";
import {
  DataCollectors,
  type EventShellData,
  type TrackEventPayload,
  trackEventPayloadZod,
} from "./types";

export const getTrackEventPayloadHandler =
  (
    dataCollectors: DataCollectors[],
    shellData: EventShellData,
    isConsentRequired: boolean,
    onesaaasConsent: Partial<OnesaasConsent>
  ) =>
  (eventPayload: TrackEventPayload) => {
    const parsed = trackEventPayloadZod.safeParse(eventPayload);

    if (!parsed.success) {
      return console.error(parsed.error);
    }

    const parsedEventPayload = parsed.data;
    const debugConsole = JSON.parse(
      sessionStorage.getItem("_debug") || "false"
    ) as boolean;

    const hasConsent = hasUserConsentedToEvent(
      parsedEventPayload,
      isConsentRequired,
      onesaaasConsent
    );

    if (!hasConsent) {
      return console.warn(
        `Couldn't figure consent for ${eventPayload.name}`,
        debugConsole
          ? {
              isConsentRequired,
              requiredPurposes: parsedEventPayload.purposes,
              onesaaasConsent,
            }
          : "turn on debug mode to see more details"
      );
    }

    if (dataCollectors.includes(DataCollectors.Datadog)) {
      const clientEvent = createClientEvent(eventPayload, shellData);

      if (debugConsole) console.log("clientEvent", clientEvent);
      if (dataCollectors.includes(DataCollectors.Datadog)) {
        datadogRum.addAction(clientEvent.eventInfo.eventType, clientEvent);
      }
    }
    if (dataCollectors.includes(DataCollectors.RudderStack)) {
      createRudderStackClientEvent(eventPayload, shellData).then(
        (rudderStackClientevent) => {
          if (debugConsole)
            console.log("rudderStackEvent", rudderStackClientevent);

          trackRudderStackEvent(
            rudderStackClientevent.event.type,
            rudderStackClientevent
          );
        }
      );
    }
    if (
      dataCollectors.includes(DataCollectors.GA4) &&
      getFeatureFlag("ga4Initiative", isBoolean, false)
    ) {
      createGA4Event(eventPayload, shellData).then((ga4Event) => {
        if (debugConsole) console.log("ga4Event", ga4Event);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(ga4Event);
      });
    }
  };
